import { useMemo } from 'react';

import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks';

import { UseFraudReviewStatisticLogicParams } from '../FraudReviewStatistic.types';

export const useFraudReviewStatisticLogic = ({ data }: UseFraudReviewStatisticLogicParams) => {
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();

  const isHidden = useMemo(() => type === OrganizationTypes.system, [type]);

  const isDetailsLinkVisible = useMemo(() => type !== OrganizationTypes.system, [type]);

  const count = useMemo(() => data?.flaggedEmployeesCount || 0, [data?.flaggedEmployeesCount]);

  return {
    count,
    isDetailsLinkVisible,
    isHidden,
  };
};

export default useFraudReviewStatisticLogic;
